module.exports = __webpack_public_path__ + "static/img/icon02.3b1959cd.png";